(function() {
  "use strict";

  angular
    .module("app")
    .controller("AssetsListController", [
      "$scope",
      "$location",
      "$timeout",
      "$sanitize",
      AssetsListController,
    ]);

  function AssetsListController($scope, $location, $timeout, $sanitize) {
    // Assets don't come from the server with any sort of unique identifier
    // For easier tracking, let's build a unique ID for each asset
    var assetIdCounter = 0;
    var generateAssetId = function() {
      assetIdCounter += 1;
      return assetIdCounter;
    };

    var processAndGroupAssets = function(obj, opts) {
      opts = opts || {};

      for (var i = 0; i < obj.length; i++) {
        var generatedId = generateAssetId();

        obj[i].id = generatedId;

        $scope.state.assetsById[generatedId] = {
          name: obj[i].name,
          isTopLevel: !opts.isChildOfGroupId,
        };

        $scope.state.assetsByName[obj[i].name] = {
          id: generatedId,
          isTopLevel: !opts.isChildOfGroupId,
        };

        if (opts.isChildOfGroupId) {
          $scope.state.assetsByGroup[opts.isChildOfGroupId].push(obj[i].id);
        }

        if (
          opts.topLevelGroupId &&
          opts.topLevelGroupId !== opts.isChildOfGroupId
        ) {
          $scope.state.assetsByGroup[opts.topLevelGroupId].push(obj[i].id);
          // console.log(opts.domainName);
        }

        if (opts.domainName) {
          $scope.state.domainsByAsset[obj[i].id] = opts.domainName;
        }

        // If this asset is a group with children, need to assign IDs for those too
        // Since this isn't the first run, we also need to pass the new group ID
        if (obj[i].children.length) {
          // Since this asset has children, create a group for it if it doesn't already exist
          $scope.state.assetsByGroup[obj[i].id] =
            $scope.state.assetsByGroup[obj[i].id] || [];
          processAndGroupAssets(obj[i].children, {
            isChildOfGroupId: obj[i].id,
            topLevelGroupId: opts.topLevelGroupId || obj[i].id,
            domainName: opts.domainName || obj[i].name,
          });
        }
      }
    };

    // First run is top-level, defines groups
    processAndGroupAssets($scope.state.assets);

    $scope.state.findGroupDomain = function(groupName) {
      var output;
      $scope.domains.forEach(function(elm, ind, arr) {
        if (groupName === elm.name) {
          output = elm;
        }
      });
      return output;
    };

    $scope.state.selectAsset = function(assetId) {
      if ($scope.state.selectedAssets.indexOf(assetId) < 0) {
        $scope.state.selectedAssets.push(assetId);
        // $scope.rrMap.styleShape($scope.state.assetsById[assetId].fips);
      }
    };
    $scope.state.selectParent = function(assetId) {
      if ($scope.state.selectedParent.indexOf(assetId) < 0) {
        $scope.state.selectedParent.push(assetId);
        // $scope.rrMap.styleShape($scope.state.assetsById[assetId].fips);
      }
    };
    if (!$scope.state.selectedAssets) {
      if ($location.search().assets) {
        var assetIds = [];
        $location
          .search()
          .assets.split("|")
          .forEach(function(asset, ind, arr) {
            // Child assets are prefixed by their parent and a slash. Break that out.
            asset = asset.split("/");
            asset = asset[asset.length - 1];
            assetIds.push($scope.state.assetsByName[asset].id);
          });
        $scope.state.selectedAssets = assetIds;
      }
      else {
        $scope.state.selectedAssets = [];
      }
    }
    
    $scope.state.hasChildAssets = function(assetId) {      
      var children = $scope.state.assetsByGroup[assetId];
      return (children && children.length > 0);
    };

    if (!$scope.state.selectedParent) {
      if ($location.search().assets) {
        var parentAssetIds = [];
        $location
          .search()
          .assets.split("|")
          .forEach(function(asset, ind, arr) {
            // Child assets are prefixed by their parent and a slash. Break that out.
            asset = asset.split("/");
            asset = asset[0];
            var candidateId = $scope.state.assetsByName[asset].id;
            if ($scope.state.hasChildAssets(candidateId)) {
              parentAssetIds.push(candidateId);
            }
          });
        $scope.state.selectedParent = parentAssetIds;
      }
      else {
        $scope.state.selectedParent = [];
      }
    }

    $scope.state.removeAsset = function(assetId) {
      var index = $scope.state.selectedAssets.indexOf(assetId);
      if (index > -1) {
        $scope.state.selectedAssets.splice(index, 1);
        // $scope.rrMap.styleShape($scope.state.communitiesById[assetId].fips);
      }
    };
    $scope.state.removeParent = function(assetId) {
      var index = $scope.state.selectedParent.indexOf(assetId);

      if (index > -1) {
        $scope.state.selectedParent.splice(index, 1);
        // $scope.rrMap.styleShape($scope.state.communitiesById[assetId].fips);
      }
    };
    $scope.state.triggerLabelClick = function(assetID, $event) {
      var element = $($event.currentTarget);
      if (
        !$(element)
          .attr("class")
          .split(" ")
          .includes("is-checked")
      ) {
        $scope.state.openAccordion(element);
      }

      $scope.state.toggleAsset(assetID);
      $scope.state.toggleParent(assetID);
    };

    $scope.state.toggleParent = function(assetId) {
      var children = $scope.state.assetsByGroup[assetId];
      var selectedAssets = $scope.state.selectedAssets;
      var hasSelectedChildren = selectedAssets.filter(function(e) {
        return children && children.indexOf(e) > -1;
      });
      if (
        $scope.state.assetChildIsSelected(assetId) &&
        hasSelectedChildren.length == 0
      ) {
        $scope.state.removeParent(assetId);
        return false;
      }
      else if ($scope.state.hasChildAssets(assetId)) {
        $scope.state.selectParent(assetId);
        return true;
      }
    };
    $scope.state.toggleAsset = function(assetId) {
      // Tracks when a user clicks on a resource checkbox button on the "Map Community Resources" page
      var resourceName = $scope.state.assetsById[assetId].name;
      dataLayer.push({
        event: "Resource Clicks",
        eventCategory: "Interactive Clicks",
        eventAction: "Resource Click|" + resourceName,
        eventLabel: window.location.pathname,
      });

      if ($scope.state.assetsByGroup[assetId]) {
        return $scope.state.toggleAssetsByParent(assetId);
      }
      else {
        if ($scope.state.assetIsSelected(assetId)) {
          $scope.state.removeAsset(assetId);
          return false;
        }
        else {
          $scope.state.selectAsset(assetId);
          return true;
        }
      }
    };

    $scope.state.toggleAccordion = function($event) {
      var element = $event.currentTarget;
      var parent = $(element).parent();
      if (
        parent
          .attr("class")
          .split(" ")
          .includes("open")
      ) {
        $(parent).removeClass("open");
      }
      else {
        $(parent).addClass("open");
      }
    };

    $scope.state.openAccordion = function(element) {
      var parent = element.parent().parent();
      if (
        !parent
          .attr("class")
          .split(" ")
          .includes("open")
      ) {
        $(parent).addClass("open");
      }
    };

    $scope.state.toggleAssetsByParent = function(groupId, forceSelect) {
      if ($scope.state.assetGroupIsSelected(groupId) && !forceSelect) {
        $scope.state.assetsByGroup[groupId].forEach(function(val, ind, arr) {
          if ($scope.state.assetsByGroup[val]) {
            return $scope.state.toggleAssetsByParent(val, true);
          }
          else {
            $scope.state.removeAsset(val);
          }
        });
        $scope.state.removeAsset(groupId);
      }
      else {
        $scope.state.assetsByGroup[groupId].forEach(function(val, ind, arr) {
          if ($scope.state.assetsByGroup[val]) {
            return $scope.state.toggleAssetsByParent(val, true);
          }
          else {
            $scope.state.selectAsset(val);
          }
        });
        $scope.state.selectAsset(groupId);
      }
    };

    $scope.state.allAssetsAreSelected = function() {
      return (
        $scope.state.selectedAssets.length ===
        Object.keys($scope.state.assetsById).length
      );
    };

    $scope.state.toggleAllAssets = function() {
      var allSelected = $scope.state.allAssetsAreSelected();

      for (var asset in $scope.state.assetsById) {
        if ($scope.state.assetsById.hasOwnProperty(asset)) {
          // Need to coerce `asset` to a Number
          if (allSelected) {
            $scope.state.removeAsset(+asset);
          }
          else {
            $scope.state.selectAsset(+asset);
          }
        }
      }
    };

    $scope.state.assetIsSelected = function(assetId) {
      if ($scope.state.assetsByGroup[assetId]) {
        return $scope.state.assetGroupIsSelected(assetId);
      }
      else {
        return $scope.state.selectedAssets.indexOf(assetId) >= 0;
      }
    };

    $scope.state.assetChildIsSelected = function(assetId) {
      var matchedArray = $scope.state.selectedParent.filter(function(e) {
        return e == assetId;
      });

      if (matchedArray.length > 0) {
        return true;
      }
    };
    $scope.state.assetGroupIsSelected = function(groupId) {
      // Quick exist if we haven't created groups yet
      if (!$scope.state.assetsByGroup[groupId]) {
        return false;
      }

      var matchedArray = $scope.state.selectedAssets.filter(function(elem) {
        return $scope.state.assetsByGroup[groupId].indexOf(elem) > -1;
      });
      if (matchedArray.length == $scope.state.assetsByGroup[groupId].length) {
        $scope.state.selectAsset(groupId);
        return true;
      }
      else {
        $scope.state.removeAsset(groupId);
        return false;
      }
    };

    $scope.state.assetGroupHasSelectedAssets = function(assetGroup) {
      for (var i = 0; i < assetGroup.children.length; i++) {
        var child = assetGroup.children[i];
        if (
          $scope.state.assetIsSelected(child.id) ||
          $scope.state.assetChildIsSelected(child.id)
        ) {
          return true;
        }
      }
      return false;
    };

    // When the selected year changes, we need to default to the highest- and
    // lowest-ranked communities ONLY if the user hasn't made any selections themselves
    $scope.state.checkForSelectedAssets = function(before) {
      // before = communitiesByRank before `selectedYear` pulled in new data
      var after = $scope.state.communitiesByRank;

      var highestRankBefore = before ? before[0] : {};
      var lowestRankBefore = before ? before[before.length - 1] : {};

      var highestRankAfter = after[0];
      var lowestRankAfter = after[after.length - 1];

      // By default, or if the only two selected communities are the old highest and
      // lowest ranked, clear the selections and select the new highest- and
      // lowest-ranking communities
      if (
        $scope.state.selectedAssets.length === 0 ||
        ($scope.state.selectedAssets.length === 2 &&
          $scope.state.assetIsSelected(highestRankBefore.id) &&
          $scope.state.assetIsSelected(lowestRankBefore.id))
      ) {
        $scope.state.selectedAssets = [];
        $scope.state.selectAsset(highestRankAfter.id);
        $scope.state.selectAsset(lowestRankAfter.id);

        // Restyle the old districts on the map if we need to
        $scope.rrMap.styleShape(highestRankBefore.fips);
        $scope.rrMap.styleShape(lowestRankBefore.fips);
      }
    };

    $scope.$watch(
      "state.selectedDomain",
      function(newDomain, prevDomain) {
        // quick exit on the first run, or if there's no default asset
        if (
          prevDomain === newDomain ||
          !$scope.state.selectedDomain.defaultAsset
        ) {
          return false;
        }

        var domain = $scope.state.selectedDomain;

        var prevDefaultAsset;
        if (prevDomain && prevDomain.defaultAsset) {
          prevDefaultAsset = $scope.state.assetsByName[prevDomain.defaultAsset.name];
        }

        var nonTopLevelAssets = $scope.state.selectedAssets.filter(function(id) {
          return !$scope.state.assetsById[id].isTopLevel;
        });

        function isSelectedAssetThePreviousDefault() {
          return prevDefaultAsset &&
            (prevDefaultAsset.id === nonTopLevelAssets[0] ||
            ($scope.state.selectedParent && $scope.state.selectedParent.includes(prevDefaultAsset.id)));
        }

        if (nonTopLevelAssets.length === 0 || (nonTopLevelAssets.length === 1 && isSelectedAssetThePreviousDefault)) {
          // ...clear any selected assets and select the new domain's default asset
          $scope.state.selectedParent = [];
          $scope.state.selectedAssets = [];
          if (!domain.defaultAsset || domain.defaultAsset.name === "0") {            
            console.warn("No default asset found for domain '" + domain.name + "'.");
            return;
          }

          var targetAsset;
          var defaultAssetChildren = domain.defaultAsset.children;
          if (defaultAssetChildren && defaultAssetChildren.length) {
            var domainAsset = $scope.state.assets.find(a => a.name === domain.name);
            if (!domainAsset) {
              console.error("Unable to find domain asset '" + domain.name + '"');
              return;
            }

            var parentAsset = domainAsset.children.find(a => a.name == domain.defaultAsset.name);
            if (!parentAsset) {
              console.error("Unable to find parent default asset '" + domain.defaultAsset.name + '"');
              return;
            }

            $scope.state.selectParent(parentAsset.id);
            targetAsset = parentAsset.children.find(a => a.name === defaultAssetChildren[0].name);
            if (!targetAsset) {
              console.error("Unable to find default child asset '" + defaultAssetChildren[0].name + "'.");
              return;
            }
          }
          else {
            targetAsset = $scope.state.assetsByName[domain.defaultAsset.name];
            if (!targetAsset) {
              console.error("Unable to find default asset '" + domain.defaultAsset.name + "'.");
              return;
            }
          }
          
          $scope.state.selectAsset(targetAsset.id);
        }
      },
      true,
    );
  }
})();
